// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card___3vPc","active":"Card_active__5oozn","image-wrapper":"Card_image-wrapper__1B953","image":"Card_image__6WT_K","text":"Card_text__exIoF"};